import React from 'react';
import { roles } from '@nxsys/store/constants';

const MessagePage = React.lazy(() => import('../../../modules/message'));

export const messageConfig = [
  {
    permittedRole: [roles.admin, roles.employer, roles.employee, roles.agency],
    path: '/messages',
    element: <MessagePage />,
  },
];
